"use client";

import dynamic from "next/dynamic";

import Skeleton from "@/components/atoms/Skeleton";
import ProductGrid from "@/components/molecules/ProductGrid";
import clsx from "clsx";
import styles from "../../plp.module.css";
import { PaginationFallback } from "./Parts/Pagination/ClientPagination";

export const PaginationSectionFallback = () => (
  <section data-layout="page">
    <PaginationFallback />
  </section>
);

export const ProductCardSkeleton = () => (
  <div className={styles.card__skeleton}>
    <div className={styles.card__image} />
    <Skeleton height={"24px"} />
    <Skeleton height={"16px"} />
    {/* needs one more of these on yarn PLP */}
    <Skeleton height={"24px"} />
  </div>
);

export const ProductGridSkeleton = () => (
  <section data-layout="page" className={styles["main-content"]}>
    <div className={styles.filter_modal_skeleton}></div>
    <div className={styles.products__wrapper}>
      <ProductGrid>
        {[...Array(6)].map((_, i) => (
          <ProductCardSkeleton key={"skeleton-card--" + i} />
        ))}
      </ProductGrid>
    </div>
  </section>
);

export const FilterBarSkeleton = () => (
  <section data-layout="page" style={{ marginBottom: 16 }}>
    <div className={clsx(styles["filters-nav"], styles.filters__skeletons)}>
      <Skeleton height={"31px"} />
      <Skeleton height={"31px"} />
      <Skeleton height={"31px"} />
    </div>
  </section>
);

export const PLPSkeleton = () => {
  return (
    <>
      <FilterBarSkeleton />
      <ProductGridSkeleton />
      <PaginationSectionFallback />
    </>
  );
};

const PLP = dynamic(() => import("./ClientPLP"), {
  ssr: true,
  loading: PLPSkeleton,
});

export default PLP;
